import React from 'react';
import { Button } from '../../../common/components';
import InternalContainer from '../../layout/containers/Internal';
import SourceForm from '../components/SourceForm/SourceForm';

const SourceCreateContainer = () => {
  const buttons = (
    <Button bsStyle="default" label="Back" isBackButton={true} leftIcon="caret-left" />
  );

  return (
    <InternalContainer title="Source" buttons={buttons}>
      <SourceForm />
    </InternalContainer>
  );
};
export default SourceCreateContainer;
